import { useMemo } from "react";
import { SortDescriptor } from "react-aria-components";
import { useSearchParams } from "react-router";

import { getSearchQuery } from "components/SearchInput/helpers";

import { AwsIntegrationView } from "../useSearchCloudIntegrations/gql";
import { sortIntegrations } from "./sort";

export const useFilteredIntegrations = (
  integrations: AwsIntegrationView[],
  sortDescriptor: SortDescriptor
) => {
  const [searchParams] = useSearchParams();
  const searchInput = getSearchQuery(searchParams);

  return useMemo(() => {
    let filteredIntegrations = [...integrations];
    // Apply search filter if exists
    filteredIntegrations = filteredIntegrations.filter((integration) =>
      integration.name.toLowerCase().includes(searchInput.toLowerCase())
    );

    // Apply sorting if descriptor exists
    if (sortDescriptor.column) {
      filteredIntegrations = sortIntegrations(filteredIntegrations, sortDescriptor);
    }

    return filteredIntegrations;
  }, [integrations, searchInput, sortDescriptor]);
};
